import React from "react";
import { InscricoesBase } from "../Components/InscricoesBase";
import { semProdutosExclusivos } from "../utils/produtoFilters";

// Página pública de inscrições e contribuições (listada no menu principal).
// A implementação vive em InscricoesBase, compartilhada com a rota exclusiva
// (/inscricoes-exclusivas). Aqui escondemos os produtos exclusivos (R$ 2,00).
export const Inscricoes = () => {
  return <InscricoesBase filtrarProdutos={semProdutosExclusivos} />;
};

export default Inscricoes;
